import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { throwIfAlreadyLoaded } from './import.guard';
import { ConfigGlobal } from './interfaces/globals/config-global.interfaces';
import { AuthService } from './services/auth/auth.service';
import { Globals } from './services/globals/globals';
import { HttpInterceptorService } from './services/http-interceptors/http-interceptor.service';
import { QbusToastService } from './services/qbus-toast/qbus-toast.service';
import { CustomTranslateLoaderService } from './services/translations/custom-translate-loader.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    CustomTranslateLoaderService,
    Globals,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  public static forRoot(config: ConfigGlobal): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        Globals,
        { provide: 'config', useValue: config },
        { provide: 'http', useClass: HttpClient },
        { provide: 'globals', useClass: Globals },
        AuthService,
        QbusToastService,
      ],
    };
  }
}
